import { Button, ButtonProps } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

interface IConfirmButton extends ButtonProps {
  text?: string
}

export default function ConfirmButton({ text, ...props }: IConfirmButton) {
  const { t } = useTranslation()
  return (
    <Button
      {...props}
      w={'100%'}
      colorScheme="purple"
      type="submit"
      size="lg"
      fontWeight={600}
      borderRadius="xl"
      _hover={{
        transform: 'translateY(-2px)',
        boxShadow: 'xl',
      }}
      transition="all 0.2s"
    >
      {text ? text : t('shared.auth.login')}
    </Button>
  )
}
